import { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProcessContext from '../../../../contexts/process/ProcessContext';
import UIContext from '../../../../contexts/ui/UIContext';
import StatusBarButton from '../../../layout/StatusBarButton';
import Loading from '../../../ui-elements/Loading';
import Tray from '../../Tray';
import SeedSlotDiscardConfirm from './SeedSlotDiscardConfirm';

const ConfirmPlantDiscarding = ({ forwardTo, completingRef }) => {
	const {
		activeProcessId,
		activeProcessType,
		processTypes,
		occupancyArray,
		taskData,
		loadOccupancy,
		additionalProcessInformation,
		continueProcess,
		resetProcessState,
		finishProcess,
	} = useContext(ProcessContext);
	const [confirmed, setConfirmed] = useState(false);
	const { loading, setInfo, clearInfo } = useContext(UIContext);
	const navigate = useNavigate();

	const loadOccupancyForEntity = async () => {
		await loadOccupancy(additionalProcessInformation.sourceEntity);
	};

	useEffect(() => {
		clearInfo();

		let base = '';
		if (typeof activeProcessType === 'string') {
			base = activeProcessType;
		} else if (typeof activeProcessType === 'number') {
			const key = Object.keys(processTypes).find((k) => processTypes[k] === activeProcessType);
			base = key || '';
		}
		const processType = base ? camelCaseToWords(base) : '—';

		const tray = additionalProcessInformation?.sourceEntity || '—';

		const plants = Array.isArray(additionalProcessInformation?.sourceSelection) ? additionalProcessInformation.sourceSelection.length : 0;
		setInfo({ processType, tray, plants });
	}, []);

	useEffect(() => {
		const entity = additionalProcessInformation?.sourceEntity;
		if (!entity) return;
		loadOccupancyForEntity();
	}, [additionalProcessInformation?.sourceEntity]);

	function camelCaseToWords(str) {
		return str
			.replace(/([a-z])([A-Z])/g, '$1 $2')
			.replace(/ing$/i, '')
			.toUpperCase();
	}

	const confirmSelection = async () => {
		try {
			setConfirmed(true);
			await continueProcess(activeProcessId, true);
			if (completingRef) {
				completingRef.current = true;
				await finishProcess();
			}
			var processIsTaskDriven = taskData != null;
			var redirectUrl = processIsTaskDriven ? taskData.redirectUrl : null;
			resetProcessState();
			if (processIsTaskDriven) {
				if (redirectUrl) {
					window.location.href = redirectUrl;
					return;
				}
				navigate('/', { state: { slide: 1 } });
				return;
			} else if (forwardTo) {
				navigate(forwardTo, { replace: true });
			}
		} catch (error) {
			console.error(error);
		}
	};

	const reversedArray = [...occupancyArray].reverse();

	if (loading || confirmed) {
		return <Loading fullScreen />;
	}

	return (
		<Fragment>
			<Tray>
				{reversedArray.map((unit) => (
					<SeedSlotDiscardConfirm
						key={unit.index}
						displayName={unit.display !== 'available' ? unit.display : ''}
						index={unit.index}
						seedType={additionalProcessInformation.seedType}
					/>
				))}
			</Tray>

			<StatusBarButton label='Confirm' icon='fas fa-check' reversed={true} type='inline' clickHandler={confirmSelection} statusSlot={5} />
		</Fragment>
	);
};

export default ConfirmPlantDiscarding;
